
import CaseList from './list/caseListDetail'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Vue from 'vue'
import Scroll from '../../base/scroll/scroll'
import {eventBus} from '../../../eventbus'
export default {
directives: {
TransferDom
},
components: {
CaseList,
Scroll,
Confirm,
Alert,
Group,
Popup,
XButton,
Flexbox,
FlexboxItem,
XDialog,
Checker,
CheckerItem,
TransferDom
},
data () {
return {
$vue: '',
caseListOption: [],
isOpen: true,
listData: [],
searchCondition: new Map(),
clickedCaseId: '',
scrollbar: true,
scrollbarFade: true,
pullDownRefresh: true,
pullDownRefreshThreshold: 90,
pullDownRefreshStop: 40,
pullUpLoad: true,
pullUpLoadThreshold: 0,
startY: 0,
scrollToX: 0,
scrollToY: -200,
scrollToTime: 700,
scrollToEasing: 'bounce',
showInvalid: false,
showError: false,
refreshResult: '',
showMoreMenu: false,

finishType: '',
showGroupDocs: false,
groupDocsList: [],
chosenGroupDocsList: [],
showNoChosenDocs: false,
showFinishDiagnose: false,
reportList: [],
showMoreReport: false
}
},
computed: {

scrollbarObj: function () {
return this.scrollbar ? {fade: this.scrollbarFade} : false
},

pullDownRefreshObj: function () {
return this.pullDownRefresh ? {
threshold: parseInt(this.pullDownRefreshThreshold),
stop: parseInt(this.pullDownRefreshStop)
} : false
},

pullUpLoadObj: function () {
return this.pullUpLoad ? {
threshold: parseInt(this.pullUpLoadThreshold),
txt: {more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt}
} : false
}
},
methods: {

initDzdCaseList () {

let yczOption = []
yczOption.url = this.$vue.getData('ALREADY_FIRST_DIAGNOSED_LIST_URL')
yczOption.listName = '初诊'
yczOption.caseListType = 'ycz'

let yfzOption = []
yfzOption.url = this.$vue.getData('ALREADY_FURTHER_CONSULTATION_LIST_URL')
yfzOption.listName = '复诊'
yfzOption.caseListType = 'yfz'

let yhzOption = []
yhzOption.url = this.$vue.getData('ALREADY_CONSULTATION_LIST_URL')
yhzOption.listName = '会诊'
yhzOption.caseListType = 'yhz'

this.caseListOption.push(yczOption)
this.caseListOption.push(yfzOption)
this.caseListOption.push(yhzOption)
},

caseEvent (prop) {
this.clickedCaseId = prop.caseId
switch (prop.event) {
case 'checkFinalReport': // 查看最终初/复诊
this.checkFinalReport()
break
case 'checkHzReport': // 查看会诊
this.checkHzReport()
break
case 'checkCzDiagnoseReport': // 初诊诊断查看
this.checkDiagnoseReport(0)
break
case 'checkFzDiagnoseReport': // 复诊诊断查看
this.checkDiagnoseReport(1)
break
case 'confirmCzNextStep': // 初诊确认下步
this.finishType = 0
this.confirmNextStep()
break
case 'confirmFzNextStep': // 复诊确认下步
this.finishType = 1
this.confirmNextStep()
break
case 'finishCzDiagnose': // 初诊结束诊断
this.finishType = 0
this.finishDiagnose()
break
case 'finishFzDiagnose': // 复诊结束诊断
this.finishType = 1
this.finishDiagnose()
break
}
},

axiosPackage (url) {
let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId.toString())
return this.$http.post(url, params)
},

async checkFinalReport () {

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('IS_FINAL', '1')
let suc = await this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params)
if (suc.data.result === '1') {

this.reportDetailInfo(suc.data.data[0])
}
},

async checkHzReport () {

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('DOCTOR_ID', localStorage.getItem('ID'))
params.append('REPORT_CLASS', '2')
let suc = await this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params)
if (suc.data.result === '1') {

this.reportDetailInfo(suc.data.data[0])
}
},

async checkDiagnoseReport () {

let suc = await this.axiosPackage(this.$vue.getData('CASE_REPORT_LIST_URL'))
if (suc.data.result === '1') {
this.reportList = suc.data.data
this.showMoreReport = true
} else {
this.showError = true
}
},

async reportDetailInfo (item) {

eventBus.$emit('showLoading', true)
let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('REPORT_CLASS', item.REPORT_CLASS)
params.append('REPORT_ID', item.ID)
let suc = await this.$http.post(this.$vue.getData('REPORT_DETAIL_URL'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data} })
} else {

eventBus.$emit('showLoading', false)
this.showError = true
}
},

confirmNextStep () {
this.showMoreMenu = true

this.chosenGroupDocsList = []
},

finishDiagnose (type) {

this.showFinishDiagnose = true

this.showMoreMenu = false
},

async confirmFinishDiagnose () {
let url
if (this.finishType === 0) {

url = this.$vue.getData('CZCOMPLETE_URL')
} else if (this.finishType === 1) {

url = this.$vue.getData('FZCOMPLETE_URL')
}
let suc = await this.axiosPackage(url)
if (suc.data.result === 'success') {
if (this.finishType === 0) {

this.$refs.ycz[0].refreshList()
}
if (this.finishType === 1) {

this.$refs.yfz[0].refreshList()
}
} else {
this.showError = true
}
},

async launchGroupConsultation () {

let suc = await this.axiosPackage(this.$vue.getData('GET_GROUPDOCS_URL'))
if (suc.data.result === '1') {
let data = suc.data.data
this.groupDocsList = data
this.showGroupDocs = true
} else {
this.showError = true
}
},

async submitGroupDocs () {

if (this.chosenGroupDocsList.length === 0) {
this.showNoChosenDocs = true
return
}

eventBus.$emit('showLoading', true, '提交中...')

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('DOCTOR_IDS', this.chosenGroupDocsList.toString())
let suc = await this.$http.post(this.$vue.getData('SUBMIT_CHOSEN_GROUP_DOCS'), params)

eventBus.$emit('showLoading', false)
if (suc.data.result === '1') {
this.showGroupDocs = false
this.showMoreMenu = false
AlertModule.show({
title: '发起会诊成功',
content: '请等待相关医生进行会诊'
})

this.$refs.ycz[0].refreshList()
this.$refs.yfz[0].refreshList()
} else {
this.showError = true
}
},

getRefreshResult (prop) {
this.refreshResult = prop.result
},

onPullingDown () {

this.$refs.ycz[0].refreshList()
this.$refs.yfz[0].refreshList()
this.$refs.yhz[0].refreshList()
setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 2000)
},

onPullingUp () {

setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 1500)
},
scrollToCaseList () {

setTimeout(this.scrollTo, 200)
},
scrollTo () {

let listHeight = document.querySelector('.conterUl').offsetHeight
this.$refs.scroll.scrollTo(-listHeight + 676)
},
updateScrollbar (val) {
this.scrollbar = val
},
updateScrollbarFade (val) {
this.scrollbarFade = val
},
updatePullDownRefresh (val) {
this.pullDownRefresh = val
},
updatePullDownRefreshThreshold (val) {
this.pullDownRefreshThreshold = val
},
updatePullDownRefreshStop (val) {
this.pullDownRefreshStop = val
},
updatePullUpLoad (val) {
this.pullUpLoad = val
},
updatePullUpLoadThreshold (val) {
this.pullUpLoadThreshold = val
},
updatePullUpLoadMoreTxt (val) {
this.pullUpLoadMoreTxt = val
},
updatePullUpLoadNoMoreTxt (val) {
this.pullUpLoadNoMoreTxt = val
},
updateStartY (val) {
this.startY = val
},
updateScrollToX (val) {
this.scrollToX = val
},
updateScrollToY (val) {
this.scrollToY = val
},
updateScrollToTime (val) {
this.scrollToTime = val
},
updateScrollToEasing (val) {
this.scrollToEasing = val
},
rebuildScroll () {
Vue.nextTick(() => {
this.$refs.scroll.destroy()
this.$refs.scroll.initScroll()
})
}
},
beforeMount () {
this.$vue = this

this.searchCondition = this.$route.params.searchCondition
this.initDzdCaseList()
},
beforeRouteEnter (to, from, next) {
next(vm => {

if (from.name === 'diagnosis' || from.name === 'reportdetail') {

let listType = localStorage.getItem('listType')

eval('vm.$refs.' + listType + '[0].openListAndSetPage()')
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/caselist/yzdCaseList.vue